import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../Axiosinstance/AxiosInstance";

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        if (!username || !password) {
            setErrorMessage("Please enter both username and password");
            return;
        }

        setLoading(true);
        setErrorMessage("");

        try {
            const response = await axiosInstance.post(
                "/account/api/v1/login",
                {
                    username: username,
                    password: password,
                }
            );

            if (response && response.data) {
                const { token, refresh, data } = response.data;

                // Basic validation of response structure based on user's example
                if (!token || typeof token !== 'string') {
                    setErrorMessage('Invalid response from server');
                    setLoading(false);
                    return;
                }

                console.log("Login successful:", response.data);

                localStorage.setItem("token", token);
                localStorage.setItem("refreshToken", refresh);
                localStorage.setItem("user_info", JSON.stringify(data));
                navigate("/dashboard");
            }
        } catch (error) {
            console.error("Login error:", error);
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage("Invalid credentials or server error. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="relative flex justify-center items-center min-h-screen bg-cover bg-center bg-no-repeat font-sans px-4"
            style={{ backgroundImage: "url('/bannerimg.png')" }}
        >
            {/* Dark Overlay for better readability */}
            <div className="absolute inset-0 bg-black/50 backdrop-brightness-75"></div>

            <div className="relative z-10 bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 sm:p-10 w-full max-w-md lg:max-w-lg xl:max-w-xl 2xl:max-w-2xl shadow-2xl transition-all duration-300
                lg:p-12 xl:p-16 2xl:p-20">
                <h1 className="text-gray-100 text-3xl lg:text-4xl xl:text-5xl font-semibold mb-8 lg:mb-12 text-center tracking-tight">Admin Login</h1>
                <form onSubmit={handleSubmit} className="flex flex-col gap-6 lg:gap-8">
                    <div className="flex flex-col gap-2 lg:gap-3">
                        <label htmlFor="username" className="text-slate-400 text-sm lg:text-base font-medium">Username:</label>
                        <input
                            id="username"
                            type="text"
                            className="bg-white/5 border border-white/10 rounded-lg text-white px-4 py-3 lg:px-6 lg:py-4 text-base lg:text-lg transition-all duration-200 focus:outline-none focus:border-indigo-400 focus:bg-white/10 focus:ring-2 focus:ring-indigo-400/20"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter username"
                            disabled={loading}
                            required
                        />
                    </div>
                    <div className="flex flex-col gap-2 lg:gap-3">
                        <label htmlFor="password" className="text-slate-400 text-sm lg:text-base font-medium">Password:</label>
                        <input
                            id="password"
                            type="password"
                            className="bg-white/5 border border-white/10 rounded-lg text-white px-4 py-3 lg:px-6 lg:py-4 text-base lg:text-lg transition-all duration-200 focus:outline-none focus:border-indigo-400 focus:bg-white/10 focus:ring-2 focus:ring-indigo-400/20"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter password"
                            disabled={loading}
                            required
                        />
                    </div>
                    {errorMessage && <p className="text-red-400 text-sm lg:text-base text-center">{errorMessage}</p>}
                    <button
                        type="submit"
                        className="bg-indigo-500 text-white rounded-lg p-3 lg:p-4 text-base lg:text-xl font-semibold cursor-pointer mt-4 lg:mt-6 hover:bg-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        disabled={loading}
                    >
                        {loading ? "Logging in..." : "Login"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
